export default "__VITE_ASSET__198882cd__"